import { useState, useCallback } from 'react';

export default function useInputs(defaultValue) {
  const [input, setInput] = useState(defaultValue);

  const onChange = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    const temp = input;

    temp[name] = value;
    setInput({ ...temp });

  }, [])

  const onOneReset = useCallback((name) => {
    const temp = input;

    temp[name] = "";
    setInput({ ...temp });

  }, [])
  const onReset = useCallback(() => setInput(defaultValue), []);

  return [input, onChange, onOneReset, onReset];
}